<session-analytic-item-view
  (onExpanded)="onExpanded.emit($event)"
  [isExpanded]="isExpanded"
  [dataSummary]="summary"
  [helpDescription]="helpDescriptionKey | translate"
  [title]="titleTranslation | translate"
  [shouldTease]="shouldTease">
  <div graph>
    @if (!noWords) {
      <div class="word-normal" translate="{{normalTranslation}}"></div>
      <highcharts-chart
        #chart
        [options]="chartOptions"
      ></highcharts-chart>
      <div class="word-legend">
        @for (wordCount of wordTypeWords; track wordCount) {
          <div class="word-legend-item" data-cy="filler-word">
            <span
              class="word-count"
						[ngStyle]="{
							'color': bestContrast(wordCount.color),
							'background-color': wordCount.color
						}"
            >{{wordCount.count}}</span>
            <span class="word">{{wordCount.word}}</span>
          </div>
        }
      </div>
    } @else {
      <analytic-graph-zero-state>
        {{zeroStateTranslation | translate}}
      </analytic-graph-zero-state>
    }
  </div>
</session-analytic-item-view>
